import { render } from "./ObjectRelations.vue?vue&type=template&id=bd8da130"
import script from "./ObjectRelations.vue?vue&type=script&lang=js"
export * from "./ObjectRelations.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__